import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { allProductsById } from '../api/masters.atoms'
import { Box, Link } from '@mui/material'
import { TreeManagement } from '../components/tree/TreeManagement'
import React from 'react'
import { CheckTreeAttribution } from './AttributionValidation'
import { useGetTreeByIdWithDepth } from '../reducers/trees_hooks'
import { directTreeAccessUrl } from 'infrastructure/api'

export function EditableCopyView({ productId }: { productId: number }) {
  const product = useAtomValue(allProductsById)[productId]
  if (!product?.editable_tree) return null
  const { tree_id: treeId, version_id: versionId } = product.editable_tree
  return (
    <Box padding="5px" border={'1px solid'}>
      <Box>
        Editable Copy: <TreeLink treeId={treeId} versionId={versionId} />
      </Box>
      <Box>
        <CheckTreeAttribution
          treeId={treeId}
          versionId={versionId}
          title={'Attribution'}
        />
      </Box>
      <TreeManagement treeId={treeId} versionId={versionId} />
    </Box>
  )
}

function TreeLink(ids: { treeId: string; versionId: string }) {
  const { tree } = useGetTreeByIdWithDepth({ ...ids, depth: 0 })
  if (!tree) return null
  return (
    <Box
      component={Link}
      href={directTreeAccessUrl(ids)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {tree.title}
    </Box>
  )
}
